// extracted by mini-css-extract-plugin
export default {"panel":"ClientsPanel_panel__jGbIX","links":"ClientsPanel_links__zBjbd","content":"ClientsPanel_content__H2vuX","buttons":"ClientsPanel_buttons__njCjS"};